import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const HOURS12 = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
export const MINUTES = ["00", "05", "10", "15", "20", "25", "30", "35", "40", "45", "50", "55"];

export const composeTime = (h, m, ap) => (h && m && ap ? `${h}:${m} ${ap}` : "");

export function parseTime(v) {
  const m = /^(\d{1,2}):(\d{2})\s?(AM|PM)$/i.exec((v || "").trim());
  return m ? { hour: String(+m[1]), minute: m[2], ampm: m[3].toUpperCase() } : { hour: "", minute: "", ampm: "" };
}

export function TimeSelect({ hour, minute, ampm, onHour, onMinute, onAmpm, idPrefix, dark = false }) {
  const bg = dark ? "bg-navy" : "bg-input";
  const trg = `${bg} border-gold/20 text-white h-12`;
  return (
    <div className="grid grid-cols-3 gap-2">
      <Select value={hour} onValueChange={onHour}>
        <SelectTrigger data-testid={`${idPrefix}-hour`} className={trg}><SelectValue placeholder="Hour" /></SelectTrigger>
        <SelectContent className="max-h-60">{HOURS12.map((h) => <SelectItem key={h} value={h} data-testid={`${idPrefix}-hour-${h}`}>{h}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={minute} onValueChange={onMinute}>
        <SelectTrigger data-testid={`${idPrefix}-min`} className={trg}><SelectValue placeholder="Min" /></SelectTrigger>
        <SelectContent className="max-h-60">{MINUTES.map((m) => <SelectItem key={m} value={m} data-testid={`${idPrefix}-min-${m}`}>{m}</SelectItem>)}</SelectContent>
      </Select>
      <Select value={ampm} onValueChange={onAmpm}>
        <SelectTrigger data-testid={`${idPrefix}-ampm`} className={trg}><SelectValue placeholder="AM/PM" /></SelectTrigger>
        <SelectContent>{["AM", "PM"].map((p) => <SelectItem key={p} value={p} data-testid={`${idPrefix}-ampm-${p}`}>{p}</SelectItem>)}</SelectContent>
      </Select>
    </div>
  );
}
